if (window.quickAddOptionsExecuted == false) {
    window.quickAddOptionsExecuted = true;
    const fetchCardProduct = (productCard, productID) => {
      const productPack = JSON.parse(productCard.dataset.pack);
      const dataPackTitle = productCard.dataset.packTitle;
      const productPackTitle = dataPackTitle.replace(/[\[\]]/g, '').split(',').map(item => item.trim());
      const dataPackPrice = productCard.dataset.packPrice;
      const productPackPrice = dataPackPrice.replace(/[\[\]]/g, '').split(',').map(item => item.trim());
      if (productPack && productPack != "") {
        if (productCard.querySelector('.card__quick-options'))
          productCard.querySelector('.card__quick-options').remove();
        if (productCard.querySelector('.card__quick-options')) return;

        const productFormHeader = document.createElement('div');
        productFormHeader.className = 'card__quick-header';
        const container = document.createElement('div');
        container.className = 'card__quick-options';
        container.className += ' card__options-modal is-pack';
        const productFormFooter = document.createElement('div');
        productFormFooter.className = 'card__quick-footer';

        const buttonContainer = document.createElement('div');
        buttonContainer.classList.add('options__select-container');
        const mainItem = productPack[0];
        const additionalItems = productPack.slice(1);
        
        const mainItemButton = document.createElement('span');
        const mainItemTitle = productPackTitle[0];
        mainItemButton.className = 'card__quick--option';
        mainItemButton.className += ' selected';
        mainItemButton.textContent = `${mainItemTitle}`;
        mainItemButton.dataset.variantIds = JSON.stringify([mainItem.id]);
        if (mainItem.available == false) mainItemButton.classList.add("disabled");
        mainItemButton.addEventListener('click', (event) => changeOption(event));
        buttonContainer.appendChild(mainItemButton);

        additionalItems.forEach((item, index) => {
          const button = document.createElement('span');
          button.className = 'card__quick--option';
          const buttonTitle = productPackTitle[index+1];
          button.textContent = `${mainItemTitle} + ${buttonTitle}`;
          
          if (mainItem.available == false || item.available == false) {
            button.classList.add("disabled");
          }
      
          button.dataset.variantIds = JSON.stringify([mainItem.id, item.id]);
          if (!button.disabled) {
            button.dataset.price = productPackPrice[index+1].replace(".", ",");
          }
          button.addEventListener('click', (event) => changeOption(event));
      
          buttonContainer.appendChild(button);
        });

        container.appendChild(buttonContainer);

        const quickSelectText = document.createElement('span');
        quickSelectText.className = 'low-s light';
        quickSelectText.innerText = window.variantStrings.selectOption;
        productFormHeader.appendChild(quickSelectText);
        
        const addToCartButton = document.createElement('button');
        addToCartButton.className = 'button button--primary';
        addToCartButton.innerText = window.variantStrings.addToCart;
        addToCartButton.dataset.variantIds = JSON.stringify([mainItem.id]);
        addToCartButton.addEventListener('click', (event) => addToCart(event));
        if (mainItem.available == false) addToCartButton.setAttribute("disabled", "");
        productFormFooter.appendChild(addToCartButton);
        
        container.insertBefore(productFormHeader, container.firstChild);
        container.appendChild(productFormFooter);

        let cardContainer = productCard.querySelector('.card__media');
        cardContainer?.insertAdjacentElement('afterend', container);
        if (window.matchMedia('(max-width: 749px)').matches) {

          const card = productCard.querySelector('.card');
          
          const cardClose = document.createElement('button');
          cardClose.className = 'card__quick--options-close card__options-close link full-unstyled-link';
          cardClose.innerHTML =
            '<svg class="icon icon-close" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.560981 10L0 9.43902L4.43902 5L0 0.560981L0.560981 0L5 4.43902L9.43902 0L10 0.560981L5.56098 5L10 9.43902L9.43902 10L5 5.56098L0.560981 10Z" fill="currentColor"/></svg>';
          productFormHeader.appendChild(cardClose);

          container.insertBefore(productFormHeader, container.firstChild);

          if (card.closest('.scroll-trigger.animate--slide-in'))
            card.closest('.scroll-trigger.animate--slide-in').classList.remove('scroll-trigger', 'animate--slide-in');
            
            container.classList.add('quick-select-open-mobile');
            document.body.classList.add('quick-select-open-mobile');
            document.body.appendChild(container)

            cardClose.addEventListener('click', (evt) => {
              evt.preventDefault()
              const optionsModalBody = document.querySelector('.card__quick-options.quick-select-open-mobile');
              optionsModalBody.classList.remove('quick-select-open-mobile');
              document.body.classList.remove('quick-select-open-mobile');
              optionsModalBody.remove();
            });
        }
        setTimeout(() => {
          productCard.classList.add('has-options');
        }, 50);

      } else {
        console.error("Empty variants")
      }
    };
  
    const changeOption = (event) => {
      event.preventDefault;
      const option = event.target;
      if (!option.classList.contains("disabled") && !option.classList.contains("selected")) {
        const newVariantIds = option.dataset.variantIds;
        option.closest(".card__quick-options").querySelector("span.selected").classList.remove("selected");
        option.classList.add("selected");
        const addToCartButton = option.closest(".card__quick-options").querySelector(".card__quick-footer .button");
        if (addToCartButton.hasAttribute("disabled")) addToCartButton.removeAttribute("disabled")
        addToCartButton.dataset.variantIds = newVariantIds;
        if (addToCartButton.querySelector("span.price-pack")) addToCartButton.querySelector("span.price-pack").remove()
        if (option.dataset.price) {
          const priceSpan = document.createElement("span");
          priceSpan.className = "price-pack";
          priceSpan.textContent = option.dataset.price;
          addToCartButton.appendChild(priceSpan);
        }
      } else if (option.classList.contains("disabled")) {
        const addToCartButton = option.closest(".card__quick-options").querySelector(".card__quick-footer .button");
        if (addToCartButton) addToCartButton.setAttribute("disabled", "");
      }
    }

    const addToCart = (event) => {
      event.preventDefault();
      const button = event.target;
      let variantIds = [];
      try {
          variantIds = JSON.parse(button.dataset.variantIds);
      } catch (error) {
          console.error("Invalid JSON in dataset.variantIds:", button.dataset.variantIds);
      }

      const items = variantIds.map(id => ({
          id: id,
          quantity: 1
      }));
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items }),
      })
        .then((response) => response.json())
        .then((data) => {
          openCart(variantIds.length);
          const optionsModalBody = document.querySelector('.quick-select-open-mobile.card__quick-options');
          if (optionsModalBody) {
            optionsModalBody.classList.remove('quick-select-open-mobile');
            document.body.classList.remove('quick-select-open-mobile');
            optionsModalBody.remove();
          }

        })
        .catch((error) => {
          const optionsModalBody = document.querySelector('.quick-select-open-mobile.card__quick-options');
          if (optionsModalBody) {
            optionsModalBody.classList.remove('quick-select-open-mobile');
            document.body.classList.remove('quick-select-open-mobile');
            optionsModalBody.remove();
          }
        });
    };
  
    const openCart = (addedCount = 1) => {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
      if (cart) {
        setTimeout(() => {
          cart.classList.add('animate', 'active');
        });
    
        if (cart.querySelector('.drawer__inner-empty')) cart.querySelector('.drawer__inner-empty').remove();
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
    
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.drawer__footer'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
    
            const cartItemCountTab = document.getElementById('cart-items-count-tab');
            if (cartItemCountTab) {
              const currentCount = parseInt(cartItemCountTab.innerText.trim(), 10) || 0;
              const newCount = currentCount + addedCount;
              cartItemCountTab.innerText = newCount;
            }
    
            const cartIconBubbleElement = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
            if (cartIconBubbleElement) {
              const cartIconBubbleText = cartIconBubbleElement.innerText.trim();
              const matches = cartIconBubbleText.match(/(\D*)(\d+)(\D*)/);
  
              if (matches) {
                let countBubble = parseInt(matches[2], 10) || 0;
                countBubble += addedCount;
                const newCartIconBubble = `${matches[1]}${countBubble}${matches[3]}`;
                cartIconBubbleElement.innerText = newCartIconBubble;
              }
            }
    
            productCardsPacks();
          })
          .catch((e) => {
            console.error(e);
          });
    
        document.body.classList.add('overflow-hidden');
      }
    };
  
    function productCardsPacks() {
      const productCardWrappers = document.querySelectorAll('.product-card-wrapper:not(.product-card-bundle)');
  
      productCardWrappers.forEach((productCard) => {
        productCard.addEventListener('mouseenter', () => {
          if (window.matchMedia('(min-width: 750px)').matches) {
            productCard.classList.add('hovered');
  
            if (!productCard.classList.contains('is-executed') || !productCard.querySelector(".card__quick-options")) {
              productCard.classList.add('is-executed');
              const productID = productCard.getAttribute('data-product');
  
              fetchCardProduct(productCard, productID);
            }
          }
        });
  
        productCard.addEventListener('mouseleave', () => {
          if (window.matchMedia('(min-width: 750px)').matches) {
            productCard.classList.remove('hovered');
          }
        });
  
        productCard.querySelector('.card__quick-opener')?.addEventListener('click', () => {
          if (window.matchMedia('(max-width: 749px)').matches) {
            if (!document.querySelector(".card__options-modal")) {
              productCard.classList.remove('hovered');
              const productID = productCard.getAttribute('data-product');
              fetchCardProduct(productCard, productID);
            }
          }
        });
  
      });
    }
  
    productCardsPacks();
  }
  